import { Component, OnInit, Input } from '@angular/core';
import { ScaleResult } from 'app/shared/models/scale-result';

@Component({
  selector: 'app-scale-range-content',
  templateUrl: './scale-range-content.component.html'
})
export class ScaleRangeContentComponent implements OnInit {
  @Input() scaleResult:ScaleResult;
  @Input() expandContent:boolean;
  @Input() client:boolean;
  
  constructor() { 
    this.client = false;
  }

  ngOnInit() {
  }

  public get hasContent() {
    if (this.scaleResult && this.scaleResult.range) {
      if (this.client && this.scaleResult.range.clientContent) {
        return this.scaleResult.range.clientContent.trim() != "";
      }
      else if (this.scaleResult.range.therapistContent) {
        return this.scaleResult.range.therapistContent.trim() != "";
      }
    }
    return false;
  }


  public shouldShowContent(scaleResult:ScaleResult) {
    
    return this.expandContent && this.hasContent;
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/scale-range-content/scale-range-content.component.ts